import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadVehicleRegistryByIdFailed, loadVehicleRegistryByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* loadVehicleRegistryById(action) {
  try {
    const url = `${BACKEND_URL_V2}/dict/vehicles/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadVehicleRegistryByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadVehicleRegistryByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadVehicleRegistryByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
